import { ISelectOption, Loading } from '@aon/aon-tws-common-ui';
import { ILibraryQuestion as ICommonLibraryQuestion, IQuestionVariation } from '@aon/tws-common-ui-questions/build/lib/models';
import * as React from 'react';
import styled from 'styled-components';
import { AttributeName, IColumn, IExternalAttributeVm } from '../../../models';
import { LoadingWrapper } from '../../common';
import { DemographicQuestionListTable } from './DemographicQuestionListTable';

const hiddenContainerStyle = {
	width: '0',
	opacity: 0,
	overflow: 'hidden',
	height: '0',
};

export const ErrorBoxContainer = styled.div.attrs<{ hasDimensionSelector: boolean }>({})<{ hasDimensionSelector: boolean }>`
	margin-bottom: 40px;
	${(props) => (props.hasDimensionSelector ? '' : 'margin-top: 40px;')}
	text-align: left;
`;

export interface IDemographicQuestionContainerParams {
	selectedQuestionVariationIds: number[];
	totalSelectedQuestions: number;
}

export interface IDemographicQuestionListParams extends IDemographicQuestionContainerParams {
	questions: ICommonLibraryQuestion[];
	loading: boolean;
	columns: IColumn[];
	availableCultures: ISelectOption[];
	participantAttributes: IExternalAttributeVm[];
	surveySupportedCultures: string[];
	selectedAttributes: string[];
	GetCulturesIfNeeded: () => void;
	GetDemographicQuestions: () => void;
	UpdateColumns: (columns?: IColumn[]) => void;
	SelectQuestion: (question: ICommonLibraryQuestion, isSelected: boolean) => void;
	SelectQuestionVariation: (question: ICommonLibraryQuestion, questionVariation: IQuestionVariation, isSelected: boolean) => void;
	ShowSingleVariation: (questionId: number) => void;
}

export interface IDemographicQuestionListState {
	questions: ICommonLibraryQuestion[];
}

export class DemographicQuestionList extends React.PureComponent<IDemographicQuestionListParams, IDemographicQuestionListState> {
	constructor(props: IDemographicQuestionListParams) {
		super(props);

		this.state = {
			questions: [],
		};
	}

	public static getDerivedStateFromProps(props: IDemographicQuestionListParams, state: IDemographicQuestionListState) {
		let questions = props.questions;

		const configuredAttributes = props.participantAttributes
			.filter((map: IExternalAttributeVm) => map.attributeName !== undefined)
			.map((map: IExternalAttributeVm) => map.attributeName as AttributeName);

		questions = questions.filter(
			(q: ICommonLibraryQuestion) => q.attributeName !== undefined && configuredAttributes.indexOf(q.attributeName as AttributeName) > -1,
		);

		return { questions };
	}

	public componentDidMount() {
		this.props.GetCulturesIfNeeded();
		this.props.GetDemographicQuestions();
	}

	public render() {
		return (
			<React.Fragment>
				{this.props.loading ? (
					<LoadingWrapper>
						<Loading height={'70px'} width={'70px'} />
					</LoadingWrapper>
				) : null}
				<div style={this.props.loading ? hiddenContainerStyle : undefined}>
					<DemographicQuestionListTable {...this.props} questions={this.state.questions} />
				</div>
			</React.Fragment>
		);
	}
}
